import { render, staticRenderFns } from "./BlockHeader.vue?vue&type=template&id=337cdb5c&scoped=true&"
import script from "./BlockHeader.vue?vue&type=script&lang=ts&"
export * from "./BlockHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BlockHeader.vue?vue&type=style&index=0&id=337cdb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337cdb5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCheckbox,VCol,VRow})
